import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t border-[#2A2A2A] bg-[#0B0B0B] mt-24">
      <div className="max-w-[1360px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-3">
            <svg width="24" height="24" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="4" fill="#1565FF" />
              <circle cx="6" cy="10" r="2.2" fill="#1565FF" opacity="0.7" />
              <circle cx="26" cy="10" r="2.2" fill="#1565FF" opacity="0.7" />
              <circle cx="6" cy="22" r="2.2" fill="#1565FF" opacity="0.5" />
              <circle cx="26" cy="22" r="2.2" fill="#1565FF" opacity="0.5" />
            </svg>
            <div className="font-sans font-medium text-white">
              PEPTIDE LABS <span className="text-[#1565FF]">N.I.</span>
            </div>
          </div>
          <p className="mt-6 max-w-md text-[#B7BCC7] text-sm leading-relaxed">
            Premium laboratory research peptides manufactured to the highest standards.
            Exceptional purity. Documented consistency. Absolute transparency.
          </p>
          <div className="mt-6 label-mono">ISO-aligned QC · HPLC ≥ 99% · Cold-chain shipping</div>
        </div>

        <div>
          <div className="label-mono mb-4">Catalog</div>
          <ul className="space-y-3 text-sm text-[#B7BCC7]">
            <li><Link to="/products" className="hover:text-white transition-colors">All Products</Link></li>
            <li><Link to="/categories" className="hover:text-white transition-colors">Research Categories</Link></li>
            <li><Link to="/cart" className="hover:text-white transition-colors">Cart</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-mono mb-4">Learn</div>
          <ul className="space-y-3 text-sm text-[#B7BCC7]">
            <li><Link to="/knowledge" className="hover:text-white transition-colors">Knowledge Base</Link></li>
            <li><Link to="/reviews" className="hover:text-white transition-colors">Reviews</Link></li>
            <li><Link to="/downloads" className="hover:text-white transition-colors">Downloads</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About the Lab</Link></li>
            <li><Link to="/knowledge/laboratory-best-practices" className="hover:text-white transition-colors">Lab Best Practices</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#2A2A2A] py-6">
        <div className="max-w-[1360px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="label-mono">© {new Date().getFullYear()} Peptide Labs N.I.</div>
          <div className="text-[11px] text-[#6E7784] tracking-widest uppercase">
            For Research Use Only — Not For Human Consumption
          </div>
        </div>
      </div>
    </footer>
  );
};
